// FILE: client/src/App.js

import { Routes, Route, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { App as CapacitorApp } from "@capacitor/app";
import "./App.css";
import logo from "./assets/main-logo.png";
import WatchParty from "./pages/WatchParty";

import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Disclaimer from "./pages/Disclaimer";
import Footer from "./pages/Footer";

function SplashOverlay() {
  return (
    <div className="startupSplash">
      <img
        src={logo}
        alt="WatchParty Rooms"
        className="startupSplashLogo"
      />
    </div>
  );
}
function AppRoutes() {
  const navigate = useNavigate();
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 1100);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    let sub = null;
    let isMounted = true;

    const handleUrl = (url) => {
      if (!url) return;

      console.log("DEEPLINK URL:", url);

      try {
        const parsedUrl = new URL(url);

        const fullPath =
          (parsedUrl.pathname || "/") +
          (parsedUrl.search || "") +
          (parsedUrl.hash || "");

        console.log("DEEPLINK PATH:", fullPath);

        if ((parsedUrl.pathname || "").startsWith("/room/")) {
          navigate(fullPath, { replace: true });
        }
      } catch (err) {
        console.log("DEEPLINK ERROR:", err);
      }
    };

    const setupDeepLinks = async () => {
      try {
        const data = await CapacitorApp.getLaunchUrl();
        console.log("DEEPLINK getLaunchUrl:", data);
        if (data?.url) handleUrl(data.url);
      } catch (err) {
        console.log("DEEPLINK getLaunchUrl ERROR:", err);
      }

      try {
        const listener = await CapacitorApp.addListener("appUrlOpen", (event) => {
          console.log("DEEPLINK appUrlOpen:", event);
          if (event?.url) handleUrl(event.url);
        });

        if (isMounted) {
          sub = listener;
        } else if (listener && typeof listener.remove === "function") {
          await listener.remove();
        }
      } catch (err) {
        console.log("DEEPLINK addListener ERROR:", err);
      }
    };

    setupDeepLinks();

    return () => {
      isMounted = false;

      if (sub && typeof sub.remove === "function") {
        sub.remove();
      }
    };
  }, [navigate]);

  return (
    <>
      {showSplash && <SplashOverlay />}

      <Routes>
        <Route path="/" element={<WatchParty />} />
        <Route path="/room/:roomId" element={<WatchParty />} />

        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
      </Routes>

      <Footer />
    </>
  );
}

export default function App() {
  return <AppRoutes />;
}